
<div id="container-main" #containerMain>
    <div class="titulo">
        <img class="icon logo"  src="../../assets/images/ralarsa-logo-claro.png" />
        <div class="titulo_sub" >
            <img class="icon" style="width: 50px; margin-right: 10px;" src="../../assets/images/call_center/CC%20BLANCO.svg" />
            <h1 style="font-size: 14pt !important; color: white; padding-bottom: 10px;">Hojas Contact Center</h1>
        </div>
    </div>
    <div class="container-secciones">
        <div class="seccion" ><!--Llamada-->
            <h2>Llamada</h2>
            <div style="display: flex;">
                <div style="width:100%;">
                    <div class="campo" #padreRecomendacion>
                        <label>¿Quién le ha recomendado el taller? </label>
                        <mat-select class="bordeVerde" [(ngModel)]="llamada.recomendado" style="margin-bottom: 0px; width:100%; height:32px;">
                            <mat-option *ngFor="let opt of recomendadoList" [value]="opt.codi.trim()">{{opt.codi.trim() +" "+ opt.descripcio.trim()}}</mat-option>
                        </mat-select>
                        <mat-progress-bar *ngIf="recomendadoList.length < 1"  mode="indeterminate"></mat-progress-bar>
                    </div>
                </div>
                <div class="campo" style="width: 20%;" *ngIf="showPelayo">
                  <label></label>
                  <a class="btnCCOscuro" mat-flat-button style="width:100%" (click)="openPelayo()">Pelayo</a>
                </div>
                <div class="campo" style="width: 20%;" *ngIf="showMapfre">
                  <label></label>
                  <a class="btnCCOscuro" mat-flat-button style="width:100%" (click)="openMapfre()">Mapfre</a>
                </div>
            </div>
            <div style="display: flex;">
                  <div class="campo">
                    <label>Entrada de la llamada</label>
                    <mat-select #entradaLlamada class="bordeVerde" [(ngModel)]="llamada.entrada" (selectionChange)="onEntradaLlamadaSelected($event.value)" style="height: 32px;" tabindex="1">
                        <mat-option *ngFor="let opt of entradaLlamadasList" [value]="opt.codi.trim()">{{opt.descripcio.trim() + " " + opt.codi.trim()}}</mat-option>
                    </mat-select>
                    <mat-progress-bar *ngIf="entradaLlamadasList.length < 1"  mode="indeterminate"></mat-progress-bar>
                </div>
                <div class="campo">
                    <label>Tipo de llamada</label>
                    <mat-select class="bordeVerde" class="bordeVerde" [(ngModel)]="llamada.tipo" style="height: 32px;" tabindex="2">
                        <mat-option *ngFor="let opt of tipoLlamadaList" [value]="opt.codi.trim()">{{opt.codi.trim() +" "+ opt.descripcio.trim()}}</mat-option>
                    </mat-select>
                    <mat-progress-bar *ngIf="tipoLlamadaList.length < 1"  mode="indeterminate"></mat-progress-bar>
                </div>
                <div class="campo" *ngIf="llamada.tipo == '100'">
                  <label>Codigo postal</label>
                  <input matInput [(ngModel)]="cpllamada" tabindex="3" minlength="5" maxlength="5" pattern="^[0-9]*$"  (keypress)="allowOnlyNumbers($event)">
                </div>
            </div>
            <div style="display: flex;">
                <div class="campo">
                    <label>Origen de la llamada</label>
                    <mat-select class="bordeVerde" class="bordeVerde" [(ngModel)]="llamada.origen" style="height: 32px;" tabindex="3">
                        <mat-option *ngFor="let opt of origenLlamadaList" [value]="opt.codi.trim()">{{opt.codi.trim() +" "+ opt.descripcio.trim()}}</mat-option>
                    </mat-select>
                    <mat-progress-bar *ngIf="origenLlamadaList.length < 1"  mode="indeterminate"></mat-progress-bar>
                </div>

                <div class="campo">
                  <label>Observaciones de la llamada</label>
                  <input  [(ngModel)]="llamada.observ" matInput tabindex="8">
                </div>
            </div>
            <div style="display: flex;">
                <div class="campo" [style.width]="showGlassTalleres ? '70%' : null">
                    <label></label>
                    <button  class="btnRojo" mat-flat-button (click)="guardarLlamadaEntrante()" style="width: 100%;">Guardar llamada entrante</button>
                </div>
                <div class="campo" style="width: 30%;" *ngIf="showGlassTalleres">
                    <label></label>
                    <button class="btnVerde" mat-flat-button (click)="abrirGlassTalleres()" style="width: 100%;">Derivar a Glass Talleres</button>
                </div>
                <div class="campo" style="width: 20%;" *ngIf="showMussap">
                  <label></label>
                  <button class="btnCCOscuro" mat-flat-button style="width:100%" (click)="abrirMussap()">Web Mussap</button>
                </div>
                <div class="campo" style="width: 20%;" *ngIf="showAxa">
                  <label></label>
                  <button class="btnCCOscuro" mat-flat-button style="width:100%" (click)="abrirAxa()">Web Axa</button>
                </div>
              <div class="campo" style="width: 20%;" *ngIf="showAllianz">
                <label></label>
                <button class="btnCCOscuro" mat-flat-button style="width:100%" (click)="abrirAllianz()">Web Allianz</button>
              </div>
            </div>
        </div>
        <div class="seccion">
            <h2>Asegurado</h2>
            <div style="display: flex;"><!--INFO Asegurado-->
                <div class="campo" style="width:40%">
                    <label>DNI Cliente</label>
                    <input matInput
                    [(ngModel)]="asegurado.dni"
                    [matAutocomplete]="autoDni"
                    matTooltip="Máximo de 8 carácteres"
                           tabindex="6"
                    >
                    <mat-autocomplete #autoDni="matAutocomplete">
                        <mat-option *ngFor="let opt of aseguradosDisponiblesF | async" [value]="opt">{{opt.nom}}</mat-option>
                    </mat-autocomplete>
                  <mat-progress-bar *ngIf="!ocultarBuscaCliente"  mode="indeterminate"></mat-progress-bar>
                </div>
                <div class="campo" style="width: 30%;" >
                    <label></label>
                    <button class="btnCCOscuro" mat-flat-button style="width:100%" (click)="buscarDni(asegurado.dni)" [disabled]="!ocultarBuscaCliente" [class.disabled]="!ocultarBuscaCliente" tabindex="7">Buscar</button>
                </div>
                <div class="campo">
                    <label>Nombre cliente</label>
                    <input [(ngModel)]="asegurado.nombre" matInput tabindex="8">
                </div>
              <div class="campo" style=" margin-right: auto; width: 50%;">
                <label>Teléfono 1</label>
                <input
                  matInput [(ngModel)]="asegurado.tel1"
                  [formControl]="telefono1FormControl"
                  [ngStyle]="telefono1FormControl.invalid && telefono1FormControl.touched ? {'background-color': '#d56e00'} : {}"
                  tabindex="9"
                >
              </div>
              <div class="campo" style=" margin-right: auto; width: 50%;">
                <label>Teléfono 2</label>
                <input
                  matInput [(ngModel)]="asegurado.tel2"
                  [formControl]="telefono2FormControl"
                  [ngStyle]="telefono2FormControl.invalid && telefono2FormControl.touched ? {'background-color': '#d56e00'} : {}"
                  tabindex="10"
                >
              </div>
            </div>
            <div style="display: flex;">
            </div>
            <div style="display: flex;">
                <div class="campo" style=" margin-right: auto; ">
                    <label>Dirección Cliente</label>
                    <input matInput [(ngModel)]="asegurado.dirCliente" tabindex="11">
                </div>
            </div>
            <div style="display: flex;">
                <div class="campo" style=" width:15%;; ">
                    <label>Email</label>
                    <mat-select class="bordeVerde" [(ngModel)]="emailFacilitado" style="height: 32px;" tabindex="12">
                        <mat-option [value]="'si'">Si</mat-option>
                        <mat-option [value]="'no_tiene'">No tiene</mat-option>
                        <mat-option [value]="'no_proporcionado'">No facilitado</mat-option>
                    </mat-select>
                </div>
                <div class="campo" style="max-width:50%;">
                    <label></label>
                    <input
                        matInput [(ngModel)]="asegurado.email"
                        [disabled]="emailFacilitado!='si'"
                        [readonly]="emailFacilitado!='si'"
                        [value]="emailFacilitado=='si' ? asegurado.email : ''"
                        [formControl]="emailFormControl"
                        [ngStyle]="emailFormControl.invalid && emailFormControl.touched && emailFacilitado=='si' ? {'background-color': '#d56e00'} : {}"
                        tabindex="13"
                    >
                </div>
                <div class="campo" style="width:20%;">
                    <label>Agente</label>
                    <input matInput [(ngModel)]="asegurado.agente">
                </div>
                <div class="campo" style=" width:20%;; ">
                    <label>Póliza</label>
                    <input matInput [(ngModel)]="asegurado.poliza" tabindex="14">
                </div>
            </div>
            <div style="display: flex;">
                <div class="campo" style="width: 30%">
                    <label>Fecha Siniestro</label>
                    <input matInput [matDatepicker]="fSin" (click)="fSin.open()" [(ngModel)]="asegurado.fecSin">
                    <mat-datepicker #fSin></mat-datepicker>
                </div>
                <div class="campo" style=" margin-right: auto; width: 50%">
                    <label>Siniestro</label>
                    <input matInput [(ngModel)]="asegurado.siniestro" tabindex="32" [disabled]="enabledSin">
                </div>
                <div class="campo" style=" margin-right: auto; width: 40%">
                    <label>Servicio</label>
                    <mat-select class="bordeVerde" [(ngModel)]="asegurado.servicio" style="height: 32px;">
                        <mat-option [value]="'taller'">Taller</mat-option>
                        <mat-option [value]="'um'">Unidad móvil</mat-option>
                    </mat-select>
                </div>
                <div class="campo" style="width: 50%;" *ngIf="showObtenerSiniestro">
                  <label></label>
                  <button class="btnCCOscuro" mat-flat-button style="width:100%" (click)="obtenerSiniestro()">Obtener Siniestro</button>
                </div>
                <div class="campo" style="width: 50%;" *ngIf="showSiebel">
                  <label></label>
                  <button class="btnCCOscuro" mat-flat-button style="width:100%" (click)="datosSiebel()">SIEBEL</button>
                </div>
            </div>
            <div style="display: flex;">
            </div>
        </div>
    </div><!--FIN SECCIONES ARRIBA-->
    <div class="container-secciones">
        <div class="seccion">
            <h2>Taller y Compañía</h2>
            <div style="display: flex;">
                <div class="campo" style=" margin-left: auto; ">
                    <label>Dirección cliente y rango lineal</label>
                    <input matInput [(ngModel)]="direccion">
                </div>
                <div class="campo" style="width: 240px !important;">
                    <label></label>
                    <mat-select class="bordeVerde" style="height: 32px;" [(ngModel)]="kmDireccion">
                        <mat-option [value]="10">10 KM</mat-option>
                        <mat-option [value]="20">20 KM</mat-option>
                        <mat-option [value]="30">30 KM</mat-option>
                        <mat-option [value]="40">40 KM</mat-option>
                        <mat-option [value]="50">50 KM</mat-option>
                        <mat-option [value]="60">60 KM</mat-option>
                        <mat-option [value]="70">70 KM</mat-option>
                        <mat-option [value]="80">80 KM</mat-option>
                        <mat-option [value]="90">90 KM</mat-option>
                        <mat-option [value]="100">100 KM</mat-option>
                    </mat-select>
                </div>
                <div class="campo" style="width: 42%;;">
                    <label></label>
                    <button class="btnCCOscuro" mat-flat-button style="width:100%" (click)="mostrarTallerPreferente()">Buscar</button>
                </div>
            </div>
            <div style="display: flex;"><!--INFO TALLER-->
                <div class="campo" style="margin-right: auto;">
                    <label>Taller</label>
                        <input
                            type="text"
                            matInput
                            [formControl]="talleresDisponiblesControl"
                            [matAutocomplete]="autoTaller"
                            [(ngModel)]="tallerSeleccionado"
                            (focus)="talleresDisponiblesControl.setValue(talleresDisponiblesControl.value || '')"
                            (blur)="onTallerOCiaSeleccionadoBlur()"
                            (ngModelChange)="onTallerSeleccionadoChange($event)"
                            (dblclick)="tallerSeleccionado=null;"
                            tabindex="4"
                            [disabled]="tieneCitaReservada"  
                          />
                        <mat-autocomplete #autoTaller="matAutocomplete" [displayWith]="displayDelegacionCombo" [autoActiveFirstOption]="false">
                            <mat-option *ngFor="let opt of talleresDisponiblesF | async" [value]="opt">{{opt.delegacion+" "+opt.nombre.trim()}}</mat-option>
                        </mat-autocomplete>
                        <mat-progress-bar *ngIf="talleresDisponibles.length < 1 && llamada.entrada != ''"  mode="indeterminate"></mat-progress-bar>
                </div>
                <div class="campo" *ngIf="tallerSeleccionado" style="width: 10%">
                    <label></label>
                    <a class="btnCCOscuro" mat-flat-button style="width:100%" (click)="mostrarDatosTaller()">
                      <img src="assets/icons/icon_information.svg" alt="Icono" width="20" height="20" style="margin-top: 5px;">
                    </a>
                </div>
                <div class="campo" *ngIf="(caseID != '' && tallerBooking) || tieneCitaReservada">
                <label></label>
                <button class="btnCCOscuro" mat-flat-button style="width:100%" (click)="cargarVentanaAgendaNueva()">
                  Agendar cita
                </button>
              </div>
                <div class="campo" style=" margin-right: auto; ">
                    <label>Compañía</label>
                    <input
                        type="text"
                        matInput
                        [(ngModel)]=ciaSeleccionada
                        [formControl]="ciasDisponiblesControl"
                        [matAutocomplete]="autoCia"
                        (dblclick)="ciaSeleccionada = null;"
                        (focus)="ciasDisponiblesControl.setValue(ciasDisponiblesControl.value || '');"
                        (blur)="onTallerOCiaSeleccionadoBlur()"
                        (ngModelChange)="onCiaSeleccionadoChange($event)"
                        tabindex="5"
                    >
                    <mat-autocomplete #autoCia="matAutocomplete" [displayWith]="displayCiaCombo"[autoActiveFirstOption]="false">
                        <mat-option *ngFor="let opt of ciasDisponiblesF | async" [value]="opt">{{opt.nombre +" "+ opt.cliente}}</mat-option>
                    </mat-autocomplete>
                    <mat-progress-bar *ngIf="talleresDisponibles.length > 0 && tallerSeleccionado != null && tallerSeleccionado.nombre != '' && cias.length < 1"  mode="indeterminate"></mat-progress-bar>
                </div>
                <div class="campo" *ngIf="!bloqueoTuVoz && ciaSeleccionada" style="width: 10%">
                    <label></label>
                    <button class="btnCCOscuro" mat-flat-button style="width:100%" (click)="mostrarDatosCia()">
                      <img src="assets/icons/icon_information.svg" alt="Icono" width="20" height="20" style="margin-top: 5px;">
                    </button>
                </div>
            </div>
            <div style="display: flex;">
              <div class="campo" style=" margin-right: auto; " *ngIf="showEntidad">
                <label>Entidad</label>
                <mat-select class="bordeVerde" [(ngModel)]="entidadSeleccionada" (ngModelChange)="onEntidadChange($event)" style="margin-bottom: 0px; width:100%; height:32px;">
                  <mat-option *ngFor="let opt of entidadList" [value]="opt.codi.trim()">{{opt.codi.trim() +" "+ opt.descripcio.trim()}}</mat-option>
                </mat-select>
                <mat-progress-bar *ngIf="entidadList.length < 1"  mode="indeterminate"></mat-progress-bar>
              </div>
              <div class="campo" style=" margin-right: auto; " *ngIf="showCampa">
                <label></label>
                <button class="btnCCOscuro" mat-flat-button style="width:100%" (click)="addCampa()">Añadir Campaña</button>
              </div>
            </div>
            <div style="display: flex;"><!--CIA-->
                <div class="campo" style=" margin-right: auto; ">
                    <label>Observaciones</label>
                    <textarea style="height: 11em;" [(ngModel)]="mensajeObser"></textarea>
                </div>
                <div *ngIf="mensajeAvisoTalles !== ''"  class="campo" style=" margin-right: auto; ">
                    <label>Avisos taller</label>
                    <textarea style="height: 11em;" readonly [(ngModel)]="mensajeAvisoTalles"></textarea>
                </div>
            </div>
        </div>
        <div class="seccion">
            <h2>Vehículo</h2>
            <div style="display: flex;">
                <div class="campo" style=" margin-right: auto; ">
                    <label>Matrícula</label>
                    <input
                        matInput [(ngModel)]="vehiculo.matricula"
                        (input)="toUpperCaseMat($event)"
                        [formControl]="matriculaFormControl"
                        [ngStyle]="matriculaFormControl.invalid && matriculaFormControl.touched ? {'background-color': '#d56e00'} : {}"
                        tabindex="15"
                    >
                    <mat-progress-bar *ngIf="!ocultarBuscaMatricula"  mode="indeterminate"></mat-progress-bar>
                </div>
                <div class="campo" style="width: 2%; margin-right: 4px;">
                  <label></label>
                  <input class="chkRal" type="checkbox" [(ngModel)]="extranjera" (change)="desMatriculaControl()">
                </div>
                <div class="campo" style=" margin-right: auto; ">
                    <label></label>
                    <button class="btnCCOscuro" mat-flat-button (click)="buscarMatricula()" [disabled]="!ocultarBuscaMatricula" [class.disabled]="!ocultarBuscaMatricula" style=" width:100%" tabindex="16">
                        Buscar
                    </button>
                </div>
                <div class="campo" style=" margin-right: auto; " *ngIf="tallerBooking">
                  <label></label>
                  <button class="btnCCOscuro" mat-flat-button style="width:100%"
                          (click)="abirBuscadorPrisma()">
                    Prisma Buscador
                  </button>
                </div>
            </div>
            <div style="display: flex;">
                <div class="campo" style=" margin-right: auto; ">
                    <label>Km.</label>
                    <input matInput [(ngModel)]="vehiculo.km">
                </div>
                <div class="campo" style=" margin-right: auto; ">
                    <label>Eurocode</label>
                    <input matInput [(ngModel)]="vehiculo.eurocode">
                </div>
                <div class="campo" style=" margin-right: auto; ">
                    <label>OEM</label>
                    <input matInput [(ngModel)]="vehiculo.oem">
                </div>
                <div class="campo" style=" margin-right: auto; ">
                    <label>Bastidor</label>
                    <input matInput [(ngModel)]="vehiculo.bastidor" >
                </div>
                <div class="campo" style=" margin-right: auto; ">
                    <label>Precio</label>
                    <input matInput type="number" [(ngModel)]="vehiculo.precio" step="0.01" >
                </div>
            </div>
            <div  style="display: flex;">
                <div class="campo" style=" margin-right: auto; ">
                    <label>Marca</label>
                    <mat-select class="bordeVerde" [(ngModel)]="vehiculo.marca" style="height: 32px;" (valueChange)="cargarModelos($event)" tabIndex="17">
                        <mat-option *ngFor="let opt of marcasDisponibles" [value]="opt">{{opt}}</mat-option>
                    </mat-select>
                    <mat-progress-bar *ngIf="marcasDisponibles.length < 1"  mode="indeterminate"></mat-progress-bar>
                </div>
                <div class="campo" style=" margin-right: auto; ">
                    <label>Modelo</label>
                    <mat-select class="bordeVerde" style="height: 32px;" [(ngModel)]="vehiculo.modelo" [disabled]="vehiculo.marca==''" (valueChange)="checkAlert($event)" tabIndex="18" >
                        <mat-option *ngFor="let m of modelosDisponibles" [value]="m">{{m}}</mat-option>
                    </mat-select>
                    <mat-progress-bar *ngIf="modelosDisponibles.length < 1 && vehiculo.marca != '' "  mode="indeterminate"></mat-progress-bar>
                </div>
                <div class="campo" style=" margin-right: auto; ">
                    <label>Puertas</label>
                    <input matInput [(ngModel)]="vehiculo.puertas">
                </div>
                <div class="campo" style=" margin-right: auto; ">
                    <label>Año</label>
                    <mat-select class="bordeVerde" style="height: 32px;" [(ngModel)]="vehiculo.any" (valueChange)="cargarPuertas($event)">
                        <mat-option *ngFor="let a of yearsMatriculacion" [value]="a.toString().trim()" >{{a.toString().trim()}}</mat-option>
                    </mat-select>
                </div>
                <div class="campo" style=" margin-right: auto; ">
                    <label>Color</label>
                    <mat-select class="bordeVerde" style="height: 32px;"[(ngModel)]="vehiculo.color">
                        <mat-option *ngFor="let a of colores" [value]="a" >{{a}}</mat-option>
                    </mat-select>
                </div>
            </div>
            <div style="display: flex;">
            </div>
            <div style="display: flex;">
                <div class="campo" style=" margin-right: auto; ">
                  <label>Fecha matriculación</label>
                  <input matInput [(ngModel)]="vehiculo.matriculacion">
                </div>
                <div class="campo" style=" margin-right: auto; ">
                    <label>Descripción siniestro</label>
                    <mat-select class="bordeVerde" style="height: 32px;" *ngIf="descSiniestroList && descSiniestroList.length > 0" [(ngModel)]="vehiculo.descSiniestro" (selectionChange)="onDescSiniestroChange()" tabindex="19">
                        <mat-option *ngFor="let opt of descSiniestroList" [value]="opt.descripcio.trim()">{{opt.descripcio.trim()}}</mat-option>
                      </mat-select>
                      <mat-select class="bordeVerde" style="height: 32px;" *ngIf="!descSiniestroList || descSiniestroList.length === 0">
                        <mat-option disabled>No hay datos disponibles</mat-option>
                      </mat-select>
                </div>
                <div class="campo" style=" margin-right: auto; " *ngIf="showTrabajos">
                    <label>Trabajos a realizar</label>
                    <mat-select class="bordeVerde" style="height: 32px;" [(ngModel)]="trabajoSeleccionado">
                        <mat-option [value]="''"></mat-option>
                        <mat-option [value]="'0'">Lámina solar</mat-option>
                        <mat-option [value]="'1'">Pulido de faros</mat-option>
                        <mat-option [value]="'2'">Sustitución de elevalunas</mat-option>
                        <mat-option [value]="'3'">Tratamiento antilluvia</mat-option>
                        <mat-option [value]="'4'">Tratamiento de ozono</mat-option>
                    </mat-select>
                </div>
                <div class="campo" style=" margin-right: auto; ">
                    <label>ADAS</label>
                    <mat-select class="bordeVerde" style="height: 32px;" [(ngModel)]="selectAdas">
                        <mat-option [value]="'SI'">Si</mat-option>
                        <mat-option [value]="'NO'">No</mat-option>
                    </mat-select>
                </div>
            </div>
            <div style="display: flex;"></div>
        </div>
    </div>
    <div id="containerFin">
        <h2 style="
            background-color: #294634;
            color: white;
            text-indent: 10px;
            font-weight: bold;
            font-size: 14pt;
            font-weight: bold;
            font-size: 14pt;
            padding-top: 8px;
            padding-bottom: 8px;
        ">Consulta artículos</h2>
        <div id="articulosContainer">
            <div id="articulosAgregadosContainer">
                <table mat-table *ngIf="artsSeleccionadosSource.data.length > 0" [dataSource]="artsSeleccionadosSource" class="tabla-art" style="min-width: auto; font-family: 'Exo 2 Regular', sans-serif; font-size: 17px; letter-spacing: 0;flex:2;">
                    <!--art -->
                    <ng-container matColumnDef="articulo">
                      <th mat-header-cell *matHeaderCellDef style="background: white;">Artículo</th>
                      <td mat-cell *matCellDef="let element"> {{element.articulo}} </td>
                    </ng-container>
                    <!--EUROCODE-->
                    <ng-container matColumnDef="eurocode">
                      <th mat-header-cell *matHeaderCellDef style="background: white;">Eurocode</th>
                      <td mat-cell *matCellDef="let element"> {{element.eurocode}} </td>
                    </ng-container>
                    <!--desc-->
                    <ng-container matColumnDef="descripcion">
                      <th mat-header-cell *matHeaderCellDef style="background: white;">Descripción</th>
                      <td mat-cell *matCellDef="let element"> {{element.desc}} </td>
                    </ng-container>
                    <!-- OBS-->
                    <ng-container matColumnDef="observaciones">
                      <th mat-header-cell *matHeaderCellDef style="background: white;">Observaciones</th>
                      <td mat-cell *matCellDef="let element"> {{element.observaciones}} </td>
                    </ng-container>
                    <ng-container matColumnDef="cen">
                        <th mat-header-cell *matHeaderCellDef style="background: white;">Cen.</th>
                        <td mat-cell *matCellDef="let element"> {{element.stkcen}} </td>
                    </ng-container>
                    <ng-container matColumnDef="tall">
                        <th mat-header-cell *matHeaderCellDef style="background: white;">Tall.</th>
                        <td mat-cell *matCellDef="let element"> {{element.stktall}} </td>
                    </ng-container>
                    <ng-container matColumnDef="reg">
                      <th mat-header-cell *matHeaderCellDef style="background: white;">Reg.</th>
                      <td mat-cell *matCellDef="let element"> {{element.stkReg}} </td>
                    </ng-container>
                    <ng-container matColumnDef="btn">
                        <th mat-header-cell *matHeaderCellDef style="background: white;"></th>
                        <td mat-cell *matCellDef="let element" style="background-color: #b4f4a6 !important;">
                          <a class="btnCCOscuro" mat-flat-button style="height: 100%;width:100%;" (click)="quitarArticulo(element)">Quitar</a>
                        </td>
                      </ng-container>
                    <tr mat-header-row *matHeaderRowDef="columnasArtSeleccionados" style="height: 32px;"></tr>
                   <!-- data rows -->
                    <tr mat-row *matRowDef="let row; columns: columnasArtSeleccionados;"
                    [ngClass]="{ 'odd-row': row % 2 === 1, 'even-row': row % 2 === 0 }"
                    style="height: 32px;"
                    ></tr>
                </table>
              <table mat-table *ngIf="artsSeleccionadosSource.data.length <= 0" [dataSource]="artsVacioSource" class="tabla-art" style="min-width: auto; font-family: 'Exo 2 Regular', sans-serif; font-size: 17px; letter-spacing: 0;flex:2;">
                <!--art -->
                <ng-container matColumnDef="articulo">
                  <th mat-header-cell *matHeaderCellDef style="background: white;">Artículo</th>
                  <td mat-cell *matCellDef="let element"> {{element.articulo}} </td>
                </ng-container>
                <!--EUROCODE-->
                <ng-container matColumnDef="eurocode">
                  <th mat-header-cell *matHeaderCellDef style="background: white;">Eurocode</th>
                  <td mat-cell *matCellDef="let element"> {{element.eurocode}} </td>
                </ng-container>
                <!--desc-->
                <ng-container matColumnDef="descripcion">
                  <th mat-header-cell *matHeaderCellDef style="background: white;">Descripción</th>
                  <td mat-cell *matCellDef="let element"> {{element.desc}} </td>
                </ng-container>
                <!-- OBS-->
                <ng-container matColumnDef="observaciones">
                  <th mat-header-cell *matHeaderCellDef style="background: white;">Observaciones</th>
                  <td mat-cell *matCellDef="let element"> {{element.observaciones}} </td>
                </ng-container>
                <ng-container matColumnDef="cen">
                  <th mat-header-cell *matHeaderCellDef style="background: white;">Cen.</th>
                  <td mat-cell *matCellDef="let element"> {{element.stkcen}} </td>
                </ng-container>
                <ng-container matColumnDef="tall">
                  <th mat-header-cell *matHeaderCellDef style="background: white;">Tall.</th>
                  <td mat-cell *matCellDef="let element"> {{element.stktall}} </td>
                </ng-container>
                <ng-container matColumnDef="reg">
                  <th mat-header-cell *matHeaderCellDef style="background: white;">Reg.</th>
                  <td mat-cell *matCellDef="let element"> {{element.stkReg}} </td>
                </ng-container>
                <ng-container matColumnDef="btn">
                  <th mat-header-cell *matHeaderCellDef style="background: white;"></th>
                  <td mat-cell *matCellDef="let element" style="background-color: #b4f4a6 !important;">
                    <a class="btnCCOscuro" mat-flat-button style="height: 100%;width:100%;" disabled="true">Quitar</a>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="columnasArtSeleccionados" style="height: 32px;"></tr>
                <!-- data rows -->
                <tr mat-row *matRowDef="let row; columns: columnasArtSeleccionados;"
                    [ngClass]="{ 'odd-row': row % 2 === 1, 'even-row': row % 2 === 0 }"
                    style="height: 32px;"
                ></tr>
              </table>
            </div>
        </div>
    </div>

    <div class="styebtnAbajo">
      <div style = "display: flex; flex-direction: column; width: 70%" >
        <div style="margin-bottom: 10px;" class="styRow">
          <button class="btnCCOscuro" *ngIf="showemailLD" mat-flat-button (click)="mostrarGestionPeticionWeb('lineaDirecta')">Emails Línea Directa</button>
          <button class="btnCCOscuro" *ngIf="showGestionAlp" mat-flat-button (click)="mostrarGestionPeticionAlp('alphabet')">Gest. Alphabet</button>
          <!--<button class="btnCCOscuro" *ngIf="showGestionDrivalia" mat-flat-button (click)="mostrarGestionPeticionAlp('drivalia')">Gest. Drivalia</button>-->
          <button class="btnCCOscuro" *ngIf="showGestionRauda" mat-flat-button (click)="mostrarGestionPeticionWeb('rauda')">Gest. IA</button>
          <button class="btnCCOscuro" *ngIf="showGestionnuevaWeb" (click)="mostrarGestionPeticionWeb('gestionWebNew')" mat-flat-button>Gestión nueva web</button>
        </div>
        <div style="margin-bottom: 10px;" class="styRow">
          <button class="btnCCOscuro" *ngIf="showGestionweb" (click)="mostrarGestionPeticionWeb('gestionWeb')" mat-flat-button>Gestión web</button>
          <button class="btnCCOscuro" *ngIf="showGestionVarias" mat-flat-button [disabled]="habGestionVarias" (click)="mostrarBuscadorPeticiones()">Gestiones varias</button>
          <!--<button class="btnCCOscuro" *ngIf="showOutbound" (click)="mostrarGestionPeticionWeb('outbound')" mat-flat-button>Outbound</button>-->
          <button class="btnCCOscuro" *ngIf="showSegurCaixa" (click)="mostrarGestionPeticionWeb('segurCaixa')" mat-flat-button>Segur Caixa</button>
           <!--<a class="btnCCOscuro" mat-flat-button (click)="mostrarGestionPeticionWeb('caser')">Emails Caser</a>-->
          <button class="btnCCOscuro" *ngIf="showGestionMobili" mat-flat-button (click)="mostrarGestionPeticionAlp('mobilize')">Gest. Mobilize</button>
        </div>
      </div>
      <div style="width: 30%">
        <button id="btnGuardarHoja" mat-flat-button (click)="guardarHoja()" [disabled]="disableBtnGuardar " tabindex="21">Guardar Hoja </button>
      </div>
    </div>
</div>